import React from 'react';
import { StyleSheet, Text, Pressable, View } from 'react-native';
import Color from './Color';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

import { CTAButton } from '../../components';

export default function Send({
  text = '',
  containerStyle = {},
  onSend = () => {},
  children = null,
  textStyle = {},
  label = 'Send',
  alwaysShowSend = false,
  disabled = false,
}) {
  if (alwaysShowSend || text.trim().length > 0) {
    const isDisabled = disabled || !text;
    if (__WEB__) {
      return (
        <View style={{ padding: 10 }}>
          <CTAButton label="Send" disabled={isDisabled} onPress={onSend} style={styles.webBtn} />
        </View>
      );
    }
    return (
      <Pressable
        testID="send"
        accessible
        accessibilityLabel="send"
        style={[styles.container, containerStyle]}
        onPress={onSend}
        accessibilityTraits="button"
        disabled={!!isDisabled}
      >
        <View style={isDisabled ? styles.disabledText : null}>
          {children || <Text style={[styles.text, textStyle]}>{label}</Text>}
        </View>
      </Pressable>
    );
  }
  return <View />;
}

const styles = StyleSheet.create({
  container: {
    height: 60,
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabledText: {
    opacity: 0.5,
  },
  text: {
    ...FONT.regular,
    color: COLOR.emphasis,
    fontWeight: '600',
    fontSize: 18,
    backgroundColor: Color.backgroundTransparent,
    marginLeft: 10,
    marginRight: 10,
  },
  webBtn: {
    height: 45,
  },
});
